import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const Button = ({
  children,
  className,
  color = 'default',
  disabled = false,
  loading = false,
  onClick,
  size = 'regular',
  target,
  to,
  type = 'button',
}) => {
  const baseClasses = 'btn relative select-none w-full md:inline-block md:w-auto md:mr-4 mb-4 md:mb-0 last:mb-0 last:md:mr-0'
  
  const sizeClasses = {
    small: 'text-sm py-1.5 px-4 min-h-[36px]',
    regular: 'text-base py-2.5 px-6 min-h-[44px]',
    large: 'text-lg py-3 px-10 min-h-[52px]',
  }
  
  const colorClasses = {
    default: 'btn-warm',
    confirm: 'btn-secondary',
    gray: 'btn-gray',
    cancel: 'btn-cancel',
    text: 'bg-transparent border-0 text-gray-7 hover:bg-gray-2 hover:text-gray-8 focus:ring-gray-4 focus:ring-offset-2',
  }
  
  const disabledClasses = disabled || loading ? '' : ''
  
  const classesList = classNames(
    baseClasses,
    sizeClasses[size],
    colorClasses[color],
    disabledClasses,
    className
  )

  switch (type) {
    case 'anchor':
      return (
        <a
          className={classesList}
          href={to}
          onClick={onClick}
          rel={target === '_blank' ? 'nofollow noopener noreferrer' : undefined}
          target={target}
        >
          {children}
        </a>
      )

    default:
      return (
        <button
          className={classesList}
          disabled={disabled || loading}
          onClick={onClick}
          type={type}
        >
          <span className={loading ? 'invisible' : ''}>{children}</span>
          {loading && (
            <span className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
              <span className="inline-block h-5 w-5 animate-spin rounded-full border-2 border-white border-l-transparent" />
            </span>
          )}
        </button>
      )
  }
}

Button.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.any,
  color: PropTypes.oneOf(['cancel', 'confirm', 'default', 'gray', 'text']),
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  size: PropTypes.oneOf(['small', 'regular', 'large']),
  target: PropTypes.string,
  to: PropTypes.string,
  type: PropTypes.oneOf(['anchor', 'button', 'reset', 'submit']),
}

export default Button
